import script from "./CardProjectActivityBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CardProjectActivityBase.vue?vue&type=script&setup=true&lang=js"

import "./CardProjectActivityBase.vue?vue&type=style&index=0&id=f888d88c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f888d88c"]])

export default __exports__